import { showPopup } from '@/components/PopupContainer/popupService';
import ProfileImage from '@/features/users/ui/ProfileImage';
import { i18n } from '@/localization/i18n';

const POPUP_ID = 'photo-viewer-popup';

/**
 * Global handler to open the profile photo viewer modal.
 * Follows the project's standardized naming pattern (handle-prefix).
 *
 * @param {Object} params - The photo viewer parameters
 * @param {string|Blob} params.imageUri - The image source (ID, URL, or Blob)
 * @param {string} params.userId - The unique identifier for the user
 */
export const handleOpenPhotoViewer = ({ imageUri, userId }) => {
   if (!imageUri) return;

   showPopup({
      id: POPUP_ID,
      visible: true,
      title: i18n.t('user.PROFILE_PHOTO'),
      className: 'profile-popup ct-popup-animate',
      body: (
         <ProfileImage imageUri={imageUri} userId={userId} className="ct-whfull ct-aspect-square" alt="Profile Photo" />
      ),
   });
};
